import React, { useEffect, useState } from "react"

import axios from "src/axios"

function MatchingQuestionsCount({ grouped = false, tagList, requireAll }) {
  const [tags, setTags] = useState(tagList.sort())
  const [count, setCount] = useState("")

  useEffect(() => {
    const newTags = tagList.sort()
    if (tags.join() !== newTags.join()) setTags(newTags)
  }, [tagList, tags, setTags])

  useEffect(() => {
    const api = grouped
      ? "/api/admins/tailored_question_groups"
      : "/api/admins/tailored_questions"

    if (tags.length === 0) {
      setCount("")
    } else {
      axios
        .get(api, {
          params: { tags, require_all: requireAll },
        })
        .then(response => {
          setCount(response.data.total)
        })
    }
  }, [tags, grouped, requireAll])

  const label = grouped ? "Matching Question Groups" : "Matching Questions"
  return (
    <span className="text-lg font-bold">
      {label}: {count}
    </span>
  )
}

export default MatchingQuestionsCount
